import { atom } from "recoil";

export const monitorTypesState = atom<string[] | undefined>({
  key: 'monitorTypesState',
  default: undefined,
});